import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const mainColor = '#1B344A';
const secondaryColor = '#3E5B74';

export default function CheckoutSuccess() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const sessionId = searchParams.get('session_id');

    const [sessionData, setSessionData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (sessionId) {
            setLoading(true);
            axios.get(`${API_BASE_URL}/api/checkout/session/${sessionId}`)
                .then((res) => {
                    setSessionData(res.data);
                })
                .catch((err) => {
                    setError(err.message || 'Error fetching session details');
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [sessionId]);

    if (loading) return <p>Loading session details...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (sessionData !== null && sessionData?.paymentStatus !== 'paid') {
        return (
            <div style={{ padding: '2rem', borderRadius: 12, color: '#d32f2f', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '1rem' }}>
                <i className="bi bi-x-circle-fill checkout-unpaid-icon"></i>
                <p><strong>Error:</strong> The payment for this order was not successful. Please try again or contact support.</p>
                <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                    <Link to="/all" className="button-link" style={{ padding: '0.75rem 1.25rem', background: secondaryColor, color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 'bold' }}>
                        Continue Shopping
                    </Link>
                    <Link to="/account" className="button-link" style={{ padding: '0.75rem 1.25rem', background: 'transparent', color: secondaryColor, borderRadius: 8, textDecoration: 'none' }}>
                        View My Account
                    </Link>
                </div>
            </div>
        );

    }
    return (
        <div className="checkout-success-page">

            {sessionData && sessionData.order ? (
                <>
                    <i className="bi bi-check-circle-fill checkout-success-icon"></i>
                    <h1>Thank you for your order!</h1>
                    <p className="checkout-success-description" style={{ fontSize: '1rem', lineHeight: 1.6, color: '#333' }}>
                        Your payment was successful and your order is now being processed. You will receive an email confirmation shortly.
                    </p>
                    <div style={{ marginTop: '1.5rem', padding: '1rem', background: 'lightgray', borderRadius: 12 }}>
                        <strong>Order Details:</strong>
                        <div>Order ID: {sessionData.order.orderId}</div>
                        <div>Status: {sessionData.order.status}</div>
                        <div>Total: ${(sessionData.order.total / 100).toFixed(2)} {sessionData.order.currency}</div>
                        <div>Items: {sessionData.order.items?.length || 0}</div>
                    </div>
                </>
            ) : (
                <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#ffe6e6', borderRadius: 12, color: '#d32f2f' }}>
                    <strong>Error:</strong> The session ID is either invalid, canceled, or non-existent. Please contact support if you believe this is an error.
                </div>
            )}
            {sessionId && (
                <div style={{ marginTop: '1.5rem', padding: '1rem', background: 'lightgray', borderRadius: 12 }}>
                    <strong>Checkout session ID:</strong>
                    <div style={{ wordBreak: 'break-all', marginTop: 8 }}>{sessionId}</div>
                </div>
            )}
            <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <Link to="/all" className="button-link" style={{ padding: '0.75rem 1.25rem', background: secondaryColor, color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 'bold' }}>
                    Continue Shopping
                </Link>
                <Link to="/account" className="button-link" style={{ padding: '0.75rem 1.25rem', background: 'transparent', color: secondaryColor, borderRadius: 8, textDecoration: 'none' }}>
                    View My Account
                </Link>
            </div>
        </div>
    );
}
